import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ArrowUp",
  "use": "ArrowUp-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ArrowUp\"><path d=\"M556.288 406.187h86.955a42.667 42.667 0 0 0 30.037-72.96L543.659 204.373a42.667 42.667 0 0 0-60.075 0L353.963 333.227A42.667 42.667 0 0 0 384 406.187h86.955v384a42.667 42.667 0 0 0 85.333 0v-384z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol